import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
  getBackdrop,
  getDialogHeading,
  getFormSuccess,
  getSaveCancel,
} from '../../common/commonUtils/commonUtils';
import FormInputText from '../../common/Forms/FormTextField';
import {
  CBP_INVOICE_UPDATE_URL,
  formDateFormat,
  paperProps,
  yesNoDropdown,
} from '../../../constants';
import InputDropdown from '../../common/Forms/InputDropdown';
import { setStopApi } from '../../../services/StopApi/StopApi';
import { Form } from '../../ui/styled';

const CbpInvoiceListDialog = (props) => {
  const { open, setOpen, openBackdrop, authToken, fetchData } = props;

  const dispatch = useDispatch();
  const [formSuccess, setFormSuccess] = useState(false);

  const cbpInvoiceForm = useSelector((state) => state.cbpInvoiceForm);
  const { CbpInvID, DateFaxed, DateRecived, Signed } = cbpInvoiceForm;

  const defaultValue = {
    CbpInvID: CbpInvID,
    DateFaxed: moment(DateFaxed).format(formDateFormat),
    DateRecived: moment(DateRecived).format(formDateFormat),
    Signed: Signed,
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
  });
  const { handleSubmit, reset, control } = useFunction;

  useEffect(() => {
    reset(defaultValue);
  }, [
    defaultValue.CbpInvID,
    defaultValue.DateFaxed,
    defaultValue.DateRecived,
    defaultValue.Signed,
  ]);

  const handleClose = () => {
    setOpen(false);
    reset(defaultValue);
  };

  const onSubmit = (data) => {
    const { DateFaxed, DateRecived, Signed } = data;
    const url = `${CBP_INVOICE_UPDATE_URL}/${CbpInvID}`;
    const authorization = authToken;
    const payload = {
      DateFaxed: DateFaxed,
      DateRecived: DateRecived,
      Signed: Signed,
    };
    setStopApi({ url, payload, authorization }).then((response) => {
      if (response.succeeded === true) {
        fetchData();
        setFormSuccess(true);
        setOpen(false);
      }
    }).catch((e) => alert(e));
  };

  const getCbpInvoiceForm = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormInputText
            name='DateFaxed'
            type='date'
            control={control}
            shrink={true}
            label='Date Faxed'
          />
          <FormInputText
            name='DateRecived'
            type='date'
            control={control}
            shrink={true}
            label='Date Recived'
          />
          <InputDropdown
            name='Signed'
            control={control}
            options={yesNoDropdown}
            label='Signed'
          />
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <Dialog open={open} PaperProps={paperProps}>
        {openBackdrop ? (
          getBackdrop(openBackdrop)
        ) : (
          <>
            {getDialogHeading(
              'Cbp Invoice ID',
              defaultValue?.CbpInvID,
              handleClose
            )}
            <Form>
              {getCbpInvoiceForm()}
              {getSaveCancel(handleClose, null, handleSubmit(onSubmit))}
            </Form>
          </>
        )}
      </Dialog>
      {getFormSuccess(formSuccess, setFormSuccess)}
    </>
  );
};

export default CbpInvoiceListDialog;
